import React from 'react';

const ThreeDotsButton = () => (
  <span className="icon icon-3dots three-dots-button" />
);

export default ThreeDotsButton;
